import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Stack,
  Container,
  Chip,
  Card,
  FormControlLabel,
  Checkbox
} from '@mui/material';

import { useTranslation } from 'react-i18next';

import List from 'components/List2';

import { getContractsProvider } from 'services/requests/contract';
import { setMask } from 'utils';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default function ContractsProvider() {
  const { t } = useTranslation('common');
  const listRef = useRef(null);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams()

  const [statusClosed, setStatusClosed] = useState(null);

  const searchFromUrlPSellerId = searchParams.get('seller_id') || undefined
  const searchFromUrlPending = searchParams.get('pending') || undefined

  const listConfig = {
    placeholderFilter: t('contracts.search'),
    onClick: row => navigate(`/contratos/detalhe/${row.id}`),
    fields: [
      { key: 'number', label: 'Nº', desktopColumnSize: 1, isPrimary: true },
      { key: 'name', label: 'Cliente', desktopColumnSize: 2 },
      { key: 'goal', label: 'Objetivo', desktopColumnSize: 2, sm_prefix: 'Objetivo: ' },
      { key: 'amount', label: 'Valor pactuado', desktopColumnSize: 2, customValue: row => setMask('money', row.amount) },
      { key: 'installments', label: 'Parcelas', desktopColumnSize: 2, customValue: row => row.installments },
      {
        key: 'status', label: 'Status', desktopColumnSize: 3, customValue: row => (
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row">
              <Chip label={row.statusLabel} size="small" variant="outlined" color={row.statusColor} />
            </Stack>
          </Stack>
        )
      }
    ]
  }

  useEffect(() => {
    if (listRef?.current && statusClosed !== null) {
      listRef.current.refreshData()
    }
  }, [statusClosed])

  return (
    <>
      <Helmet>
        <title> {t('contractsProvider.pageTitle')} | { process.env.REACT_APP_PROJECT_NAME } </title>
      </Helmet>

      <Container>
        <Card sx={{ px: 3, py: 1, mb: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                name="status"
                onChange={e => setStatusClosed(e.target.checked)}
              />
            }
            label="Mostrar contratos finalizados e cancelados"
          />
        </Card>

        <List
          config={listConfig}
          getData={(params) => getContractsProvider({
            ...params,
            closed: statusClosed,
            sellerId: searchFromUrlPSellerId,
            pending: searchFromUrlPending
          })}
          parseData={({ id, number, name, goal, amount, installmentscount, installmentspayed, status }) => ({
            id, number, name, goal, amount, status,
            installments: `Pagas ${installmentspayed}/${installmentscount}`,
            statusLabel: t(`contracts.status.${status}`),
            statusColor: status === 'created' ? 'info' : status === 'pendingSign' || status === 'signed' || status === 'borrowed' ? 'warning' : status === 'cancelled' ? 'error' : 'success'
          })}
          ref={listRef}
        />
      </Container>
    </>
  )
}
